import '../styles/main.scss';
import { Timeline } from './Timeline';
document.addEventListener('DOMContentLoaded', () => {
    const timeline = new Timeline();
    timeline.initialize('timeline-container');
});
